import { isHeavyEquipmentObject } from '~/App/views/ObjectPage/helpers';
import ProcessObject from '../interfaces/ProcessObject';

const useShowExclVat = (processObject: ProcessObject) => {
  const isHeavyEquipment = isHeavyEquipmentObject(processObject);
  const hasDeductibleVat = processObject?.deductibleVat;

  const showExclVat = isHeavyEquipment && hasDeductibleVat;

  return showExclVat;
};

export default useShowExclVat;
